export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'fattahone_access_token',
  REFRESH_TOKEN: 'fattahone_refresh_token',
  SELECTED_STORE: 'fattahone_selected_store',
  SELECTED_COMPANY: 'fattahone_selected_company',
  THEME: 'fattahone_theme',
  ENABLED_FEATURES: 'fattah_enabled_features',
  ONBOARDING_STATE: 'erp_onboarding_state',
  ONBOARDING_DONE: 'erp_onboarding_done',
  ONBOARDING_PRODUCTS_DONE: 'erp_onboarding_products_done',
  /** 'fattah-one' = multi-product picker; absent after module-direct signup */
  ONBOARDING_FLOW: 'erp_onboarding_flow',
  ENTRY_MODULE: 'fattahone_entry_module',
  PENDING_ENTRY_MODULE: 'fattahone_pending_entry_module',
  /** Active UI workspace (POS, CRM, …) — especially for org owners with unscoped JWT. */
  WORKSPACE_MODULE: 'fattahone_workspace_module',
  /** Last known product module for login redirect after logout / session expiry. */
  LAST_MODULE_SIGN_IN: 'fattahone_last_module_sign_in',
  IDENTITY_TOKEN: 'fattahone_identity_token',
  IDENTITY_SESSION: 'fattahone_identity_session',
} as const;
